import React from "react";
import { useTranslation } from "@emisgroup/acp-application-intl";
import { useDispatch } from "react-redux";
import { ErrorAlertType, IErrorAlertObject } from "../../../../ErrorAlert/redux/Types";
import { OUTPUT_CONFIG_MAP_HIGHLIGHT } from "../../Constant";
import { ErrorAlertSlice } from "../../../../ErrorAlert/Index";
import { ButtonVariantType } from "../../../../Common/UI/Types";
import { AlertItem } from "./Types";
import Delete from "~icons/ic/outline-delete-outline";

interface DeleteConfigProps {
  /**
   * Handler for on delete
   */
  onDelete: () => Promise<void>;
  /**
   * Alert contents
   */
  alertItem: AlertItem;
  /**
   * Config map id
   */
  mapId?: string;
}

/**
 * Responsible for remove output config view
 * @param props Contains delete method
 * @returns Component JSX
 */
export const OutputConfigRemoveView: React.FC<DeleteConfigProps> = (props: DeleteConfigProps): JSX.Element => {
  const { onDelete, alertItem, mapId } = props;
  const { t: translate } = useTranslation();
  const dispatch = useDispatch();

  /**
   * Action to be performed when confirmation button is clicked in alert dialog
   */
  const onConfirmAlert = (): void => {
    onDelete();
  };

  /**
   * Method for showing the delete dialog
   */
  const onClick = (): void => {
    if(mapId) {
      const element = document.getElementById(mapId);
      if (element && element.classList.contains(OUTPUT_CONFIG_MAP_HIGHLIGHT)) {
        element.classList.remove(OUTPUT_CONFIG_MAP_HIGHLIGHT);
      }
    }
    const errorContent: IErrorAlertObject = {
      title: alertItem.title,
      message: [
        alertItem.FirstMessage,
        alertItem.Content + "?",
        alertItem.SecondMessage
      ],
      actionButtonText: translate("Button.Delete"),
      cancelButtonText: translate("Button.Cancel"),
      actionClick: () => onConfirmAlert(),
      buttonVarient: ButtonVariantType.Danger,
      type: ErrorAlertType.WARNING,
    };
    dispatch(ErrorAlertSlice.actions.createErrorAlert(errorContent));
  };

  return (
    <>
      <div
        id="ebt-outputConfig-config-mapping-delete"
        onClick={onClick}
      >
        <Delete
          title="delete"
        />
      </div>
    </>
  );
};
